<template>
  <div :style="{'width': imgWidth, 'top': top, 'left': left, 'right': right, 'bottom': bottom}"
       class="tree img-w">
    <svg viewBox="0 0 484 160" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="383.264" y="-41" width="200" height="600" rx="100" transform="rotate(45 383.264 -41)" fill="url(#paint0_linear_2_628)"/>
      <defs>
        <linearGradient id="paint0_linear_2_628" x1="579.018" y1="-28.2227" x2="234.323" y2="86.6906" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFD939"/>
          <stop offset="0.06" stop-color="#FFD33B"/>
          <stop offset="0.38" stop-color="#FFB145"/>
          <stop offset="0.65" stop-color="#FF9C4B"/>
          <stop offset="0.83" stop-color="#FF954D"/>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
  export default {
    name: "Plate",
    props: {
      imgWidth: {
        default: '7rem'
      },
      top: {
        default: 'auto'
      },
      left: {
        default: 'auto'
      },
      right: {
        default: 'auto'
      },
      bottom: {
        default: 'auto'
      },
      color: {
        default: 'white'
      }
    },
  }
</script>

<style scoped lang="scss">
  .tree {
    position: absolute;
    z-index: 50;

    &.is-yellow {
      svg * {
        fill: $yellow;
      }
    }
    &.is-white {
      svg * {
        fill: white;
      }
    }
  }
</style>
